import { render, staticRenderFns } from "./alter-user-info.vue?vue&type=template&id=2948886c&scoped=true"
import script from "./alter-user-info.vue?vue&type=script&lang=js"
export * from "./alter-user-info.vue?vue&type=script&lang=js"
import style0 from "./alter-user-info.vue?vue&type=style&index=0&id=2948886c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948886c",
  null
  
)

export default component.exports